import styled from 'styled-components'

import { colors } from '../../../constants'
import Sizes from '../Input.sizes'

interface TextAreaProps {
    borderColor?: string | boolean
    noresize?: boolean
    size?: Sizes
}

const TextArea = styled.textarea<TextAreaProps>`
    background: ${colors.greylightest};
    ${({ borderColor }) => (borderColor ? `border: 1px solid ${borderColor};` : `border: 1px solid ${colors.greylight};`)}
    border-radius: 3px;
    outline: none;
    overflow: auto;
    padding: 5px;
    size: lg;
    &:active,
    &:focus,
    &:hover {
        border: 1px solid ${colors.grey};
    }

    ${({ noresize }) => noresize && 'resize: none;'}

    ${({ size }) => {
        switch (size) {
            case Sizes.SM:
                return 'width: 115px; height: 50px;'
            case Sizes.MD:
                return 'width: 250px; height: 75px;'
            case Sizes.LG:
                return 'width: 400px; height: 100px;'
            case Sizes.XL:
                return 'width: 520px; min-height: 180px;'
            case Sizes.NONE:
                return 'width: 100%;'
            default:
                return ''
        }
    }}
`

export { TextArea }
